import queryString from 'query-string';
import createLoader from './createLoader';
import loadScriptWithCallback from './loadScriptWithCallback';
var loadGoogleApi = createLoader(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? 'https://apis.google.com/js/api.js' : _ref$url,
      _ref$callback = _ref.callback,
      callback = _ref$callback === void 0 ? "onGoogleApiLoaded_".concat(new Date().getTime()) : _ref$callback,
      _ref$withClient = _ref.withClient,
      withClient = _ref$withClient === void 0 ? true : _ref$withClient;

  return loadScriptWithCallback("".concat(url, "?").concat(queryString.stringify({
    onload: callback
  })), callback).then(function () {
    return withClient ? new Promise(function (resolve) {
      window.gapi.load('client', resolve);
    }) : null;
  });
}, function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$withClient = _ref2.withClient,
      withClient = _ref2$withClient === void 0 ? true : _ref2$withClient;

  return typeof window.gapi !== 'undefined' && (!withClient || typeof window.gapi.client !== 'undefined') ? window.gapi : null;
});
export default loadGoogleApi;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/services/es/loadGoogleApi.js
// module id = null
// module chunks = 